module.exports = __webpack_public_path__ + "img/4-r.161003d0.png";